module.exports = __webpack_public_path__ + "img/sk.d8e0e96.svg";